export const OfficeAccessoriesCustomCreateState = {
	url: '/accessories/create',
	title: 'Office Custom Accessories - Create',
	template: '<office-accessories-create-custom-page></office-accessories-create-custom-page>',
	params: {
		prod_id: null,
		bu_id: null,
	},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeAccessoriesCustomCreatePageMod" */
			'@Containers/office-accessories-page/custom-create/custom-create.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
